import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ix-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormActionsComponent {

}
